import { Box, Link, Typography } from "@mui/material";
import React from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const Disclaimer = () => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      mt={1}
      mb={6}
    >
      <Typography variant="caption" color="text.secondary" sx={{ mr: 1 }}>
        AI-generated content may be inaccurate.
      </Typography>
      <Link
        href="#"
        underline="hover"
        variant="caption"
        color="primary"
        sx={{ mr: 0.5 }}
      >
        See terms
      </Link>
      <InfoOutlinedIcon sx={{ fontSize: 16, color: "text.secondary" }} />
    </Box>
  );
};

export default Disclaimer;
